"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTerminateEmployee = exports.USE_TERMINATE_EMPLOYEE_ACTION = void 0;
const ac_1 = require("@app/ac");
const terminate_employee_1 = require("@app/ac/terminate-employee");
const confirm_1 = __importDefault(require("@app/component/modals/confirm"));
const actions_on_shifts_1 = __importDefault(require("@app/component/modals/confirm/actions-on-shifts"));
const ui_1 = require("@app/component/ui");
const request_1 = require("@app/request");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_modal_1 = require("@app/util/modal/use-modal");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const employee_card_context_1 = require("../employee-card-context");
exports.USE_TERMINATE_EMPLOYEE_ACTION = 'USE_TERMINATE_EMPLOYEE';
const useTerminateEmployee = ({ userId, workspaceId, deleteDate, setEndNow, endNow, }) => {
    const { addModal } = (0, use_modal_1.useModal)();
    const { employee } = (0, employee_card_context_1.useEmployeeCard)();
    const dispatch = (0, store_1.useRootDispatch)();
    const employees = (0, store_1.useRootSelector)((state) => state.employees);
    const immediately = endNow === true;
    const shiftsActionFnRef = react_1.default.createRef();
    if ((0, util_1.isUndefined)(workspaceId)) {
        throw new Error('useTerminateEmployee: workspaceId cannot be undefined');
    }
    return async () => {
        if (!(0, util_1.isValue)(userId)) {
            react_hot_toast_1.default.custom(() => (react_1.default.createElement(ui_1.Alert, { type: ui_1.Alert.TYPES.ERROR, text: `${(0, util_1.t)('REPLY_ERROR')} ${(0, util_1.t)('ERROR_SCREEN_HELP_TROUBLESHOOTING')}` })));
            return;
        }
        const shifts = await (0, request_1.requestShifts)({
            user: userId,
            id: workspaceId,
            period: {
                start: (0, moment_1.default)(),
                end: (0, moment_1.default)().add(1, 'year'),
            },
        }, undefined, {
            includeUncommitted: false,
        });
        const shiftsAfterDate = shifts?.filter((s) => (0, moment_1.default)(s.period?.start).isAfter((0, moment_1.default)(deleteDate).endOf('day')));
        const submitTerminateEmployee = async () => {
            const _userId = employee.user?.id;
            if (!(0, util_1.isValue)(_userId))
                return;
            if (!(0, util_1.isValue)(workspaceId))
                return;
            dispatch((0, ac_1.isLoading)(exports.USE_TERMINATE_EMPLOYEE_ACTION));
            await dispatch((0, terminate_employee_1.terminateEmployee)({
                endNow,
                deleteDate,
                employees,
                workspaceId,
                userId: _userId,
            }));
            setEndNow(undefined);
        };
        addModal(confirm_1.default, {
            type: ui_1.Alert.TYPES.WARNING,
            title: (0, util_1.t)('BATCH_EMPS_CONTRACT_DELETE'),
            subtitle: (0, util_1.t)('CONFIRM_DELETE_ROLE_SUBTITLE'),
            recordsList: shiftsAfterDate,
            text: (react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.VERTICAL, size: ui_1.Spacing.SIZES.SIZE_16 },
                react_1.default.createElement(ui_1.Flex, null,
                    react_1.default.createElement(ui_1.Text, null,
                        (0, util_1.t)('EMPLOYEE'),
                        ":"),
                    react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.HORIZONTAL, size: ui_1.Spacing.SIZES.SIZE_4 }),
                    react_1.default.createElement(ui_1.Text, null, `${employee.user?.firstName ?? '??'} ${employee.user?.lastName ?? '??'}`)),
                react_1.default.createElement(ui_1.Flex, null,
                    react_1.default.createElement(ui_1.Text, null,
                        (0, util_1.t)('EMPLOYEE_PROFILE_ROLE_END_DATE'),
                        ":"),
                    react_1.default.createElement(ui_1.Spacing, { type: ui_1.Spacing.TYPES.HORIZONTAL, size: ui_1.Spacing.SIZES.SIZE_4 }),
                    react_1.default.createElement(ui_1.Text, null, (immediately ? (0, moment_1.default)() : (0, moment_1.default)(deleteDate)).format('D.M.YYYY'))),
                shiftsAfterDate?.length ? (react_1.default.createElement(actions_on_shifts_1.default
                // @ts-expect-error
                , { 
                    // @ts-expect-error
                    labelTxt: (0, util_1.t)('CONFIRM_DELETE_ROLE_RELATED_SHIFTS_X', {
                        x: shiftsAfterDate.length,
                    }), shifts: shiftsAfterDate ?? [], shiftsActionFnRef: shiftsActionFnRef })) : null)),
            confirmLabel: (0, util_1.t)('DELETE'),
            onConfirm: async () => {
                await shiftsActionFnRef.current?.();
                submitTerminateEmployee();
                dispatch((0, ac_1.isLoading)(exports.USE_TERMINATE_EMPLOYEE_ACTION, true));
            },
            cancelLabel: (0, util_1.t)('CLOSE'),
            onCancel: () => {
                dispatch((0, ac_1.isLoading)(exports.USE_TERMINATE_EMPLOYEE_ACTION, true));
            },
        });
    };
};
exports.useTerminateEmployee = useTerminateEmployee;
